/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface TaskTeam { 
    readonly id: number;
    name: string;
}
export const TaskTeam_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const TaskTeam_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];


